import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  standalone:true,
  selector: 'app-input-file',
  templateUrl: './input-file.component.html',
  styleUrls: ['./input-file.component.scss'],
  imports: [CommonModule, FormsModule], // Assurez-vous d'importer CommonModule et les modules requis ici

})
export class InputFileComponent implements OnInit {
  selectedFile: File | null = null;
  @Input() imageUrl: string | ArrayBuffer | null = "assets/images/user/download.png";

  @ViewChild('fileInput') fileInput: ElementRef;
  @Output() fileSelected = new EventEmitter<File>();

  @Input() containerClass: string = 'col-md-4 justify-content-end';
  @Input() imageStyle = { 'width': '75%' };
  @Input() imageClass: string = 'img-thumbnail bg-white rounded-lg shadow-sm';
  @Input() buttonStyle: { [key: string]: string } = { 'width': '75%' };
  @Input() buttonClass: string = 'btn btn-primary mt-1';
  @Input() chooseButtonText: string = 'Choisir';


  constructor() { }

  ngOnInit() {
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.selectedFile = file;

      // Lire et afficher l'image sélectionnée
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageUrl = e.target.result;
      };
      reader.readAsDataURL(file);
      this.fileSelected.emit(file);

    }
  }

  // Cette fonction sera appelée lorsque le bouton "Click to upload!" est cliqué
  getFile() {
    this.fileInput.nativeElement.click();
  }



}
